// extracted by mini-css-extract-plugin
export default {"invite":"style_invite__NN+up"};